export const BASE_URL = 'https://api.nasa.gov/planetary/apod?';
export const API_KEY = 'api_key=lXBIKau7qHM9I492YNjveWfR5wg4S8ggzMhAhJUa';

//https://api.nasa.gov/#apod for more details on the key. 